var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavCameraOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 466",
    style: {
      fill: "none"
    },
    d: "M0 0h26v26H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 770"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 125",
    d: "M114.821 21.394v14.458-14.459",
    transform: "translate(-113.954 -14.737)",
    style: {
      fill: "#23272a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 126",
    d: "M134.4 1.894h.4a.755.755 0 0 0 .8-.7.756.756 0 0 0-.8-.7H132a.755.755 0 0 0-.8.7.755.755 0 0 0 .8.7h.4v.291h2z",
    transform: "translate(-125.114 -.493)",
    style: {
      fill: "#7833ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 127",
    d: "M140.939 26.612a5.568 5.568 0 1 0 5.568 5.568 5.568 5.568 0 0 0-5.568-5.568m0 10a4.436 4.436 0 1 1 4.436-4.436 4.436 4.436 0 0 1-4.436 4.436",
    transform: "translate(-127.959 -18.294)",
    style: {
      fill: "#7833ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 128",
    d: "M136.5 5.806h-19.131a2.548 2.548 0 0 0-2.548 2.548v19.212a2.548 2.548 0 0 0 2.548 2.548H136.5a2.548 2.548 0 0 0 2.548-2.548V8.354a2.548 2.548 0 0 0-2.548-2.548m-9.565 18.752a6.557 6.557 0 0 1-5.215-10.534l-.016-.013-.374-.374a.33.33 0 0 1 0-.468l.545-.546a.331.331 0 0 1 .468 0l.364.364a6.557 6.557 0 1 1 4.228 11.57m6.265-13.786a.684.684 0 0 1-.684-.684V7.938a.684.684 0 0 1 .684-.683h.867a3.533 3.533 0 0 1 3.45 2.83.6.6 0 0 1-.617.686z",
    transform: "translate(-113.954 -4.114)",
    style: {
      fill: "#7833ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 129",
    d: "M153.281 32.684a.368.368 0 0 0-.425.347.453.453 0 0 0 .425.4 2.915 2.915 0 0 1 2.457 2.457.454.454 0 0 0 .4.425.368.368 0 0 0 .347-.425 3.658 3.658 0 0 0-3.207-3.207",
    transform: "translate(-139.875 -22.43)",
    style: {
      fill: "#7833ba"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCameraOn);
export default __webpack_public_path__ + "static/media/nav_camera_on.35ef0147fb084aae422ccc5f1c9413d7.svg";
export { ForwardRef as ReactComponent };